import { Spacings, Text, Devices } from '@styles'
import styled from 'styled-components'

export const CardContainer = styled.div`
	background: ${({ theme }) => theme.palette.background.white};
	border: 1px solid rgba(15, 23, 42, 0.08);
	border-radius: ${Spacings.SPACING_3B};
	padding: ${Spacings.SPACING_3B};
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
	cursor: pointer;
	transition:
		box-shadow 0.2s ease,
		border-color 0.2s ease;

	@media ${Devices.tablet} {
		padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_5B};
		gap: ${Spacings.SPACING_3B};
	}

	&:hover {
		border-color: rgba(15, 23, 42, 0.14);
		box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1);
	}
`

export const CardHeader = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: ${Spacings.SPACING_2B};

	@media ${Devices.tablet} {
		align-items: center;
	}
`

export const TitleRow = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_2B};
	min-width: 0;
	flex: 1;
`

export const MeetingIcon = styled.div`
	flex-shrink: 0;
	width: ${Spacings.SPACING_6B};
	height: ${Spacings.SPACING_6B};
	display: flex;
	align-items: center;
	justify-content: center;

	& > img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	& > svg {
		font-size: ${Text.X_LARGE};
		color: ${({ theme }) => theme.palette.text.blue};
	}
`

export const Title = styled.div`
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.palette.text.primary};
	min-width: 0;
	word-break: break-word;

	@media ${Devices.tablet} {
		font-size: ${Text.LARGE};
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`

export const HeaderActions = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_1B};
	flex-shrink: 0;

	@media ${Devices.tablet} {
		gap: ${Spacings.SPACING_2B};
	}
`

export const MoreButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	padding: ${Spacings.SPACING_1B};
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	color: ${({ theme }) => theme.palette.text.label};

	&:hover {
		background: ${({ theme }) => theme.palette.background.searchgrey};
	}

	& > svg {
		font-size: ${Text.M_LARGE};
	}
`

export const InfoRow = styled.div`
	display: flex;
	align-items: flex-start;
	gap: ${Spacings.SPACING_1B};
	font-size: ${Text.SMALL};
	color: ${({ theme }) => theme.palette.text.greyThree};
	min-width: 0;

	& > svg {
		font-size: ${Text.LARGE};
		flex-shrink: 0;
		color: ${({ theme }) => theme.palette.text.label};
		margin-top: 1px;
	}

	@media ${Devices.tablet} {
		align-items: center;
		gap: ${Spacings.SPACING_2B};
		font-size: ${Text.MEDIUM};

		& > svg {
			font-size: ${Text.M_LARGE};
			margin-top: 0;
		}
	}
`

export const InfoText = styled.span`
	min-width: 0;
	word-break: break-word;

	@media ${Devices.tablet} {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: normal;
	}
`

export const MeetingLink = styled.a`
	color: ${({ theme }) => theme.palette.text.blue};
	font-size: ${Text.MEDIUM};
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}
`

export const LinkRow = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_2B};
	font-size: ${Text.MEDIUM};
	color: ${({ theme }) => theme.palette.text.greyThree};
	min-width: 0;
`

export const CopyButton = styled.button`
	background: none;
	border: none;
	cursor: pointer;
	padding: ${Spacings.SPACING_1B};
	display: flex;
	align-items: center;
	color: ${({ theme }) => theme.palette.text.label};

	&:hover {
		color: ${({ theme }) => theme.palette.text.blue};
	}

	& > svg {
		font-size: ${Text.M_LARGE};
	}
`

export const DateTimeRow = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};

	@media ${Devices.mobile} {
		flex-direction: row;
		align-items: center;
		gap: ${Spacings.SPACING_4B};
		flex-wrap: wrap;
	}
`

export const AttendeesRow = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_2B};
`

export const AvatarGroup = styled.div`
	display: flex;
	align-items: center;
`


export const OverflowCount = styled.div`
	width: ${Spacings.SPACING_7B};
	height: ${Spacings.SPACING_7B};
	border-radius: 50%;
	background: ${({ theme }) => theme.palette.background.searchgrey};
	color: ${({ theme }) => theme.palette.text.greyThree};
	font-size: ${Text.EXTRA_SMALL};
	font-weight: ${Text.BOLD_500};
	display: flex;
	align-items: center;
	justify-content: center;
	border: 2px solid ${({ theme }) => theme.palette.background.white};
	margin-left: -${Spacings.SPACING_2B};
	flex-shrink: 0;

	@media ${Devices.tablet} {
		width: ${Spacings.SPACING_8B};
		height: ${Spacings.SPACING_8B};
		font-size: ${Text.SMALL};
	}
`

export const AttendeeCount = styled.span`
	font-size: ${Text.SMALL};
	color: ${({ theme }) => theme.palette.text.greyThree};
	margin-left: ${Spacings.SPACING_1B};

	@media ${Devices.tablet} {
		font-size: ${Text.MEDIUM};
		margin-left: ${Spacings.SPACING_2B};
	}
`
